import { gql } from '@/__generated__';
import { GetDevicesGraveyardQuery } from '@/__generated__/graphql';

export type GraveyardDevice = GetDevicesGraveyardQuery['devices'][number];

const GET_DEVICES_GRAVEYARD = gql(`#graphql
  query GetDevicesGraveyard {
    devices(input: { deleted: ONLY_TRUE, orderBy: ID_ASC, includeGates: true }) {
      id
      profile {
        id
        name
        organization {
          id
          name
        }
        operationalStates {
          value
          timestamp
        }
      }
      metrics {
        flow {
          lastData
          unit
          precision
        }
        level {
          lastData
          unit
          precision
        }
        velocity {
          lastData
          unit
          precision
        }
      }
    }
  }
`);

export default GET_DEVICES_GRAVEYARD;
